<template>
  <div class="financing">
    <van-nav-bar left-arrow fixed placeholder @click-left="onClickLeft" v-show="!inpshow" ref="navBar">
      <van-icon name="search" slot="right" @click="inpshow = !inpshow" />
      <template slot="title">
        <router-link to="/financing/project" replace>融资项目申请表</router-link>
        <router-link to="/financing/needs" replace>融资需求采集</router-link>
      </template>
    </van-nav-bar>
    <van-sticky v-show="inpshow" ref="searchDom">
      <van-search v-model="inpVal" show-action placeholder="请输入关键字搜索" @search="onSearch" @cancel="searchCancel()"
        class="back-tran" />
    </van-sticky>
    <keep-alive>
      <router-view :inpshow="inpshow" :searchVal="searchVal" :scrollTop="navBarHeight"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'financing',
  data () {
    return {
      inpshow: false, // 搜索框展示隐藏
      inpVal: '', // 搜索内容
      searchVal: '', // 前一次搜索内容
      navBarHeight: 44 // 头部高度
    }
  },
  watch: {
    inpshow () {
      this.getScrollTop()
    }
  },
  mounted () {
    this.getScrollTop()
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    // 获取头部顶部高度
    getScrollTop () {
      this.$nextTick(() => {
        if (this.inpshow) {
          this.navBarHeight = this.$refs.searchDom.$el.offsetHeight
        } else {
          this.navBarHeight = this.$refs.navBar.$el.offsetHeight
        }
      })
    },
    // 搜索取消
    searchCancel () {
      this.inpshow = !this.inpshow
      if (this.searchVal) {
        this.searchVal = ''
      }
    },
    // 回车搜索事件
    async onSearch (val) {
      if (val === '') {
        this.$toast('请输入搜索内容')
        return false
      }
      this.searchVal = val
    }

  }
}
</script>

<style scoped lang="less">
.financing {
  height: 100%;
  background-color: #fbfbfb;
  /deep/ .van-nav-bar {
    line-height: 88px;
    .van-nav-bar__title {
      max-width: 100%;
      a {
        padding: 10px;
        border: 1px solid #ccc;
        color: #323233;
        &.router-link-active {
          background-color: #2dadb1;
          color: #fff;
        }
        &:first-child {
          border-right: none;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
        &:last-child {
          border-left: none;
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }
  /deep/ .van-icon-search,
  /deep/ .van-icon-plus {
    font-size: 40px;
    color: #2dadb1 !important;
    font-weight: 700;
  }
  /deep/ .van-icon-plus {
    padding-left: 48px;
  }
}
</style>
<style lang="less">
.financing {
  .van-sticky--fixed {
    background-color: #fbfbfb;
  }
  .head {
    height: 52px;
    line-height: 52px;
    background: rgba(45, 173, 177, 1);
    padding: 14px 32px;
    .van-col {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
  }
  .van-list {
    .van-cell {
      padding: 0 24px;
      margin: 20px auto;
      background-color: #fbfbfb;
      overflow: initial;
      .van-cell__value {
        overflow: initial;
      }
    }
  }
  .list {
    height: 118px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    .no-docking {
      position: absolute;
      top: 0;
      left: 10px;
      width: 30px;
      height: 44px;
      background-color: red;
      line-height: 30px;
      text-align: center;
      color: #fff;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 0;
        border-bottom: 15px solid white;
        border-right: 15px solid transparent;
        border-left: 15px solid transparent;
      }
    }
    .van-col {
      text-align: center;
      line-height: 28px;
    }
  }
  .operation {
    line-height: 80px;
    background: rgba(45, 173, 177, 1);
    .van-col {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
  }
  /deep/ .van-popup--bottom {
    width: 95%;
    left: 18px;
  }

  .information {
    padding: 82px 60px 33px 60px;
    color: #151515;
    .docking {
      margin-top: 42px;
      .tel {
        display: block;
        width: 240px;
        height: 80px;
        line-height: 80px;
        background: rgba(20, 189, 123, 1);
        font-size: 34px;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
      .foot {
        div {
          width: 240px;
          height: 80px;
          line-height: 80px;
          background: #2dadb1;
          font-size: 34px;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          margin-left: 44px;
        }
        display: flex;
        padding: 0 40px;
        margin-top: 65px;
      }
      p {
        margin-bottom: 24px;
        margin-top: 0;
      }
    }
    p {
      font-size: 30px;
      font-weight: 400;
      color: rgba(21, 21, 21, 1);
      margin-top: 33px;
    }
  }

  .m35 {
    margin-top: 35px;
    font-size: 30px;
    font-weight: 400;
    color: rgba(45, 173, 177, 1);
  }
}
</style>
